import bStreetCollisionLogo from '../assets/text-updates/b-street-collision.png';

export interface TextUpdatesLocation {
	name: string;
	city?: string;
	state?: string;
}

export interface TextUpdatesShop {
	name: string;
	/** Unguessable path token required to open the page. */
	accessToken: string;
	/** Short mark shown when no logo is available (1–3 chars). */
	initials: string;
	/** Optional shop logo asset (preferred over initials). */
	logo?: string;
	/** Shop contact phone shown after opt-in (10 digits, US). */
	contactPhone?: string;
	/** External privacy / terms page linked from the opt-in form. */
	privacyPolicyUrl?: string;
	/** Primary brand color for accents / CTA. */
	accent: string;
	/** Softer accent for backgrounds / hover. */
	accentSoft: string;
	locations: Record<string, TextUpdatesLocation>;
}

/**
 * Mock shop configs for the public SMS opt-in page.
 * Replace with an API lookup keyed by shopSlug when backend is ready.
 */
export const TEXT_UPDATES_SHOPS: Record<string, TextUpdatesShop> = {
	'b-street-collision': {
		name: 'B Street Collision Center',
		accessToken: '69fa476dee4d8a2c4fe566f6',
		initials: 'BS',
		logo: bStreetCollisionLogo,
		contactPhone: '4025550100',
		privacyPolicyUrl: 'https://bstreetcollision.com/privacy-policy/',
		accent: '#1F6FB2',
		accentSoft: '#E3F0F9',
		locations: {
			irvington: {
				name: 'Irvington',
				city: 'Omaha',
				state: 'NE',
			},
		},
	},
};

export function getTextUpdatesShop(
	shopSlug: string | undefined,
	accessToken?: string | undefined
): TextUpdatesShop | null {
	if (!shopSlug) return null;
	const shop = TEXT_UPDATES_SHOPS[shopSlug];
	if (!shop) return null;
	if (!accessToken || accessToken !== shop.accessToken) return null;
	return shop;
}

export function getTextUpdatesLocation(
	shop: TextUpdatesShop,
	locSlug: string | null
): TextUpdatesLocation | null {
	if (!locSlug) return null;
	return shop.locations[locSlug] ?? null;
}
